<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Inbound No：{{ formData.amzFtyInboundNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.amzFtyInboundStatus === 'N'
              ? 'primary'
              : formData.amzFtyInboundStatus === 'Y'
              ? 'success'
              : formData.amzFtyInboundStatus === 'N'
              ? 'danger'
              : 'warning'
          "
        >
          {{ formData.v_amzFtyInboundStatus || 'New' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_amzPurchaseNo') || '采购单号'">
            <el-input v-model="formData.amzPurchaseNo" clearable readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_amzFtyNoticeInNo') || '入库通知单号'"
          >
            <el-input v-model="formData.amzFtyNoticeInNo" clearable readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_inboundDate') || '入库日期'"
            prop="inboundDate"
          >
            <el-date-picker
              v-model="formData.inboundDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_scm') || '工厂'" prop="scmCode">
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_buyer') || '采购人员'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.buyerName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalQty') || '总入库数量'">
            <el-input v-model="totalQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalAmount') || '总入库金额'">
            <el-input v-model="totalAmount" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '成本货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalCtnQty') || '总箱数'">
            <el-input v-model="totalCtnQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_totalGrossWeight') || '入库总毛重(KGS)'"
          >
            <el-input v-model="totalGrossWeight" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalCbm') || '入库总体积(CBM)'">
            <el-input v-model="totalCbm" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <SkuTable
      class="mt-1"
      ref="skuTable"
      :disabled="disabled"
      :amzFtyInboundCode="amzFtyInboundCode"
      :scmCode="formData.scmCode"
      :table="table"
      @change="skuChange"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import SkuTable from '../sku-table'
import validate from '@/libs/util.validate'
import { add } from '@/libs/util.number.js'
import EditLoading from '@/mixins/edit-loading'
import dayjs from 'dayjs'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  components: { SkuTable },
  props: {
    disabled: { type: Boolean, default: true },
    amzFtyInboundCode: { type: String, default: '' },
    scmCode: { type: String, default: '' },
    table: { type: Array, default: () => [] },
  },
  data() {
    return {
      currencyUnitParams: { dictType: 'currencyUnit' },
      formData: {
        inboundDate: dayjs(new Date()).format('YYYY-MM-DD'),
        buyerCode: '',
        buyerName: '',
        totalQty: 0,
        totalAmount: 0,
        totalCtnQty: 0,
        totalGrossWeight: 0,
        totalCbm: 0,
      },
      rules: {
        inboundDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'change',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        buyerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    totalQty() {
      return format(this.formData.totalQty) || 0
    },
    totalAmount() {
      return format(this.formData.totalAmount) || 0
    },
    totalCtnQty() {
      return format(this.formData.totalCtnQty) || 0
    },
    totalGrossWeight() {
      return format(this.formData.totalGrossWeight) || 0
    },
    totalCbm() {
      return format(this.formData.totalCbm) || 0
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.amzFtyInboundCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.buyerCode = userCode || ''
        this.formData.buyerName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
    scmCode: {
      handler(val) {
        if (val) {
          this.formData = {
            ...this.formData,
            scmCode: val || '',
            currencyUnit: 'CNY',
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    reload() {
      this.getData()
      this.$refs.skuTable.getData()
    },
    getData() {
      if (!this.amzFtyInboundCode) return
      this.$api
        .ecomAmzFtyInboundDetailApi({
          amzFtyInboundCode: this.amzFtyInboundCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      if (!(await this.formValidate())) return

      const details = await this.$refs.skuTable.getTableData()
      const params = { ...this.formData, details }

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzFtyInboundSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.amzFtyInboundCode) {
        this.reload()
        return
      }

      const { amzFtyInboundCode = '', amzFtyInboundNo = '' } = body || {}
      if (amzFtyInboundCode) {
        this.$router.replace({
          name: 'ecom-awsBiz-ftyInbound-detail',
          params: { amzFtyInboundCode, pageType: 'edit' },
          query: { amzFtyInboundNo },
        })
        return
      }
    },
    skuChange(data) {
      let totalQty = 0
      let totalAmount = 0
      let totalCtnQty = 0
      let totalGrossWeight = 0
      let totalCbm = 0

      if (data && data.length) {
        totalQty = data
          .map((item) => item.inboundQty)
          .reduce((r, n) => add(r, n), 0)
        totalAmount = data
          .map((item) => item.subAmount)
          .reduce((r, n) => add(r, n), 0)
        totalCtnQty = data
          .map((item) => item.ctnQty)
          .reduce((r, n) => add(r, n), 0)
        totalGrossWeight = data
          .map((item) => item.subGrossWeight)
          .reduce((r, n) => add(r, n), 0)
        totalCbm = data
          .map((item) => item.subCbm)
          .reduce((r, n) => add(r, n), 0)
      }

      this.formData.totalQty = totalQty
      this.formData.totalAmount = totalAmount
      this.formData.totalCtnQty = totalCtnQty
      this.formData.totalGrossWeight = totalGrossWeight
      this.formData.totalCbm = totalCbm
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const detailsResult = await this.$refs.skuTable.validate()
      return formResult && detailsResult
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
